// Converts common video links (YouTube watch/short/shorts, Vimeo, Google Drive)
// into an embeddable iframe URL. Returns the original URL if already embeddable
// or unrecognized.
export function toEmbedUrl(url) {
  if (!url || typeof url !== "string") return "";
  const u = url.trim();

  // Already an embeddable player URL
  if (/\/embed\//.test(u) || /player\.vimeo\.com/.test(u) || /\/preview/.test(u)) return u;

  // YouTube: watch?v=, youtu.be/, shorts/, /live/
  const yt =
    u.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  if (yt && yt[1]) {
    // preserve start time if present (t= or start=)
    const t = u.match(/[?&](?:t|start)=(\d+)/);
    const start = t ? `?start=${t[1]}` : "";
    return `https://www.youtube.com/embed/${yt[1]}${start}`;
  }

  // Vimeo: vimeo.com/123456789
  const vm = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm && vm[1]) return `https://player.vimeo.com/video/${vm[1]}`;

  // Google Drive: /file/d/<id>/view -> /preview
  const gd = u.match(/drive\.google\.com\/file\/d\/([A-Za-z0-9_-]+)/);
  if (gd && gd[1]) return `https://drive.google.com/file/d/${gd[1]}/preview`;

  return u;
}
